import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Home from '../Homepage/Home';
import Navigationbar from '../Navigation/Navigationbar';
import AutomationServices from '../AutomationServices/AutomationServices';
import Botcatalog from '../BotCatalog/Botcatalog';
import BotDetailPage from '../BotCatalog/BotDetailPage';
import AddBot from '../AddBot/AddBot';
import Statecheck from '../Authentication/Statecheck'
import Footer from '../Footer/Footer';
import './App.css';
import Dashboard from '../Authentication/Dashboard';
import Userexist from '../Errorpages/Userexist';
import NitaRanaTemplate from '../Clients/NitaRana/NitaRanaTemplate';

class App extends Component {
  constructor(props) {
    super(props);
    this.openChat = this.openChat.bind(this);
  }
  openChat() {
    var displaySetting = document.getElementById('chatWebApp').style.display.toString();
    if ('block' === displaySetting) {
      document.getElementById('chatWebApp').style.display = 'none';
      document.getElementById('chatButtonId').style.borderRadius = '10%';
      document.getElementById('chatButtonId').style.backgroundColor = 'blue';
      document.getElementById('chatButtonId').style.color = 'white';
    } else {
      document.getElementById('chatButtonId').style.borderRadius = '30%';
      document.getElementById('chatButtonId').style.color = 'white';

      if (document.getElementById('chatWebApp').getAttribute('src').toString() !== "") {
        //Do nothing since the iframe src is already there. 
      } else {
        document.getElementById('chatWebApp').src = 'https://webchat.botframework.com/embed/Tinqer_FAQ_BOT?s=H0JHP4Ef37Q.cwA.AwU.PQVVDbDoRqVVZtuN0HAk9mQ-UUhFrK218TrPXRc0eUE';
      }
      document.getElementById('chatWebApp').style.display = 'block';
    }


  }
  render() {
    return (
      <div className="App">
        <Navigationbar />
        <Router>
          <div>
            <Route exact path='/' component={Home} />
            <Route exact path='/AutomationServices' component={AutomationServices} />
            <Route exact path='/catalog' component={Botcatalog} />
            <Route path='/catalog/:botName' component={BotDetailPage} />
            <Route exact path='/AddBot' component={AddBot} />
            <Route exact path='/signin' component={Statecheck} />
            <Route path='/developers/:username' component={Dashboard} />
            <Route path='/error/:errormsg' component={Userexist} />
            <Route path="/clients/:clientName" component={NitaRanaTemplate} />
          </div>
        </Router>
        <div id="chatBtnDiv">
          <button className="chatButton" id='chatButtonId' type="button" onClick={() => this.openChat()}><i className="far fa-comments"></i>
          </button>
          <iframe className="webchat" id="chatWebApp" style={{ display: 'none' }} name="Frequently Asked Questions"
            src=''></iframe>
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;


 /*  constructor(props) {
      super(props);
      this.state = {
        message: null,
        fetching: true
      };
    }
  
   componentDidMount() {
      fetch('/')
        .then(response => {
          if (!response.ok) {
            throw new Error(`status ${response.status}`);
          }
          return response.text();
        })
        .then(json => {
          this.setState({
            message: json.message,
            fetching: false
          });
        }).catch(e => {
          this.setState({
            message: `API call failed: ${e}`,
            fetching: false
          });
        })
    } 

     <div className="App-header">
          <h2>Welcome to React</h2>
        </div>
        <p className="App-intro">
          {'This is '}
          <a href="https://github.com/mars/heroku-cra-node">
            {'create-react-app with a custom Node/Express server'}
          </a><br />
        </p>
        <p className="App-intro"> Hello:
          {this.state.fetching ? 'Fetching message from API' : this.state.message}
        </p>

        */



// WEBPACK FOOTER //
// ./src/app/App.js